export default __webpack_public_path__ + "static/media/img-gtl-crs@3x.e871fd73.png";